import { connect } from 'react-redux';
import NonPatientActivityForm from '../../features/NonPatientActivities/Form/NonPatientActivityForm';
import globals from '../../globals/communityGlobals';
import { checkFeatureAccess } from '../../utils/helpers';
import { getSelectorOptions } from '../../actions/uiElements/selectors/getOptions';

const mapStateToProps = ({
  global: { auth },
  uiElements: {
    selectors: { clinicians },
  },
}) => {
  const access = auth.featureAccessList;
  // eslint-disable-next-line no-nested-ternary
  const clinicianOptions = clinicians ? clinicians.options : [];
  return {
    access,
    canEditTreatments: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canTriggerSync),
    clinicianOptions,
  };
};

const mapDispatchToProps = dispatch => ({
  getClinicianOptions: data => dispatch(getSelectorOptions('GetCliniciansOptionsForUser', 'clinicians', data)),
});

const NonPatientActivityFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NonPatientActivityForm);

export default NonPatientActivityFormContainer;
